export const SECTIONS: string[] = []
export type SectionName = never
export function getFieldsForSection(_s: any): any[] { return [] }
export function isFieldVisible(_key: string, _settings: any): boolean { return false }
export const RESOURCES: Record<string, any> = {}
export type FieldType = string
export type VisibleWhen = { variable: string; value: string }
export type ResourceDef = { section: string; description: string; type: string; defaultValue: any }
